import * as TWEEN from '@tweenjs/tween.js';
import { Random } from '@/etc/easings'

export const DEFAULT_DURATION = 5
export const HEADER_HEIGHT = 47
export const HEADER_COLLAPSED_HEIGHT = 28 //HEADER_HEIGHT - 20
export const BLOCK_HEIGHT = 50
export const BLOCK_BIG_HEIGHT = BLOCK_HEIGHT + 20
export const COLLAPSED_HEIGHT = 4
// Transcript warp Phase 3: audio strip height when the audio lane is expanded
// for transcript/waveform editing.
export const AUDIO_LANE_EXPANDED_STRIP_HEIGHT = 220
export const TIMELINE_PREVIEW_OVERLAP_PX = 12
export const MAX_TRACK_DEPTH = 2

// Editor viewport shift: the editor has no manual scroll, so revealing the bottom
// of the animation panel is a two-state animated jump of the #app scroller.
// Tuned by eye to land the top of the preview player at the top of the viewport,
// which scrolls all four tracks off-screen. Deliberately a fixed value rather
// than derived from the track stack, so the distance stays predictable. The
// tween clamps to the available overflow, so a taller window shifts less.
export const EDITOR_SCROLL_SHIFT_PX = 230
export const EDITOR_SCROLL_ANIM_MS = 300
// Two-finger gesture is direction-only: accumulate to a threshold, fire one
// state change, then latch against same-direction momentum, which keeps
// emitting long after the fingers lift. The latch clears after an idle gap in
// the wheel stream, or immediately when the user reverses direction hard
// enough to cross the threshold again.
export const EDITOR_WHEEL_THRESHOLD_PX = 30
export const EDITOR_WHEEL_IDLE_MS = 180

export const ZOOM_STEP = 0.15
export const ZOOM_MAX_SEC = 2
export const VIEW_MAX_PADDING = 60
export const ANIMATION_NAMES_WIDTH = 200
export const SIDE_PANEL_OPEN = 350
export const SIDE_PANEL_CLOSED = 50
export const TRACK_CPANEL_WIDTH = 70

export const GIZMO_SIZE = 50

export const SpeedOptions = () => {
  const ret = []
  const one32 = 0.03125
  let pos = one32
  let del = 32
  let i = 0
  while( pos <= 8 ) {
    ret.push({
      i,
      value: pos,
      label: del > 1 ? `1/${del}` : Math.round(1/del)
    })
    pos = pos * 2
    del = del / 2
    i++
  }
  return ret
}
 
export const EASING = {
  None: ['Linear', 'Random'],
  In: ['Quadratic', 'Cubic', 'Quartic', 'Quintic', 'Sinusoidal', 'Exponential', 'Circular', 'Elastic', 'Back', 'Bounce'],
  Out: ['Quadratic', 'Cubic', 'Quartic', 'Quintic', 'Sinusoidal', 'Exponential', 'Circular', 'Elastic', 'Back', 'Bounce'],
  InOut: ['Quadratic', 'Cubic', 'Quartic', 'Quintic', 'Sinusoidal', 'Exponential', 'Circular', 'Elastic', 'Back', 'Bounce'],
  // Audio: ['Low', 'Mid', 'High']
}

export const TOOL_ICON = {
  Translate2D: ['fas', 'up-down-left-right'],
  Scale2D: ['fas', 'compress'],
  Rotate2D: ['fas', 'rotate'],
  Translate3D: ['fas', 'up-down-left-right'],
  Scale3D: ['fas', 'compress'],
  Rotate3D: ['fas', 'rotate'],
  OpacitySlider: ['fas', 'fill'],
  VolumeSlider: ['fas', 'volume-low']
}

export const EASING_FN = {
  'Linear.None': TWEEN.Easing.Linear.None,
  'Quadratic.In': TWEEN.Easing.Quadratic.In,
  'Quadratic.Out': TWEEN.Easing.Quadratic.Out,
  'Quadratic.InOut': TWEEN.Easing.Quadratic.InOut,
  'Cubic.In': TWEEN.Easing.Cubic.In,
  'Cubic.Out': TWEEN.Easing.Cubic.Out,
  'Cubic.InOut': TWEEN.Easing.Cubic.InOut,
  'Quartic.In': TWEEN.Easing.Quartic.In,
  'Quartic.Out': TWEEN.Easing.Quartic.Out,
  'Quartic.InOut': TWEEN.Easing.Quartic.InOut,
  'Quintic.In': TWEEN.Easing.Quintic.In,
  'Quintic.Out': TWEEN.Easing.Quintic.Out,
  'Quintic.InOut': TWEEN.Easing.Quintic.InOut,
  'Sinusoidal.In': TWEEN.Easing.Sinusoidal.In,
  'Sinusoidal.Out': TWEEN.Easing.Sinusoidal.Out,
  'Sinusoidal.InOut': TWEEN.Easing.Sinusoidal.InOut,
  'Exponential.In': TWEEN.Easing.Exponential.In,
  'Exponential.Out': TWEEN.Easing.Exponential.Out,
  'Exponential.InOut': TWEEN.Easing.Exponential.InOut,
  'Circular.In': TWEEN.Easing.Circular.In,
  'Circular.Out': TWEEN.Easing.Circular.Out,
  'Circular.InOut': TWEEN.Easing.Circular.InOut,
  'Elastic.In': TWEEN.Easing.Elastic.In,
  'Elastic.Out': TWEEN.Easing.Elastic.Out,
  'Elastic.InOut': TWEEN.Easing.Elastic.InOut,
  'Back.In': TWEEN.Easing.Back.In,
  'Back.Out': TWEEN.Easing.Back.Out,
  'Back.InOut': TWEEN.Easing.Back.InOut,
  'Bounce.In': TWEEN.Easing.Bounce.In,
  'Bounce.Out': TWEEN.Easing.Bounce.Out,
  'Bounce.InOut': TWEEN.Easing.Bounce.InOut,
  'Random.None': Random
}

export const VYBY_EFFECTS = {
  /*
  transform: {
    pulse: {
      uuid: 'pulse',
      name: 'Pulse',
      group: 'transform',
      vyby: true,
      preset: {}
    },
    shake: {
      uuid: 'shake',
      name: 'Shake',
      group: 'transform',
      vyby: true,
      preset: {}
    },
    glitch: {
      uuid: 'glitch',
      name: 'Glitch',
      group: 'transform',
      vyby: true,
      preset: {}
    }
  },
  */
  transform: {
    name: 'Transform',
    presets: {}
  },
  postprocessing: {
    name: 'Post-effects',
    presets: {}
  },
  blur: {
    name: 'Blur',
    presets: {}
  },
  clone: {
    name: 'Clone',
    presets: {}
  },
  lyrics: {
    name: 'Lyrics',
    presets: {}
  }
  /*
  blur: {
    'depth-blur': {
      uuid: 'depth-blur',
      name: 'Depth Blur',
      group: 'blur',
      vyby: true,
      preset: {}
    },
    'liquid-blur': {
      uuid: 'liquid-blur',
      name: 'Liquid Blur',
      group: 'blur',
      vyby: true,
      preset: {}
    },
    'motion-blur': {
      uuid: 'motion-blur',
      name: 'Motion Blur',
      group: 'blur',
      vyby: true,
      preset: {}
    },
    'vyby-blur': {
      uuid: 'vyby-blur',
      name: 'Vyby Blur',
      group: 'blur',
      vyby: true,
      preset: {}
    }
  }
  */
}

// UI schema for BlurEffect (Phase I: editor overlay config only; runtime wiring in Phase II)
export const BLUR_EFFECTS = {
  blur: {
    name: 'Blur',
    controls: {
      intensity: {
        name: 'Intensity',
        type: 'number',
        min: 0,
        max: 1,
        step: 0.01,
        slider: true
      },
      radius: {
        name: 'Radius',
        type: 'number',
        min: 0,
        max: 10,
        step: 0.1,
        slider: true
      }
    },
    defaults: {
      intensity: 0.5,
      radius: 2
    }
  }
}

// UI schema for LyricsEffect (Phase I: editor overlay config only; runtime wiring in Phase II)
export const LYRICS_EFFECT_DEFAULTS = {
  script: '',
  offset: 0
}

export const POSTPROCESSING_EFFECTS = {
  colorAdjust: {
    name: 'Color Adjust',
    controls: {
      brightness: {
        name: 'Brightness',
        type: 'number',
        min: -1,
        max: 1,
        step: 0.01,
        slider: true
      },
      contrast: {
        name: 'Contrast',
        type: 'number',
        min: -1,
        max: 1,
        step: 0.01,
        slider: true
      },
      saturation: {
        name: 'Saturation',
        type: 'number',
        min: -1,
        max: 1,
        step: 0.01,
        slider: true
      }
    },
    defaults: {
      brightness: 0,
      contrast: 0,
      saturation: 0
    }
  },
  pixelate: {
    name: 'Pixelate',
    update: 'update',
    controls: {
      pixelSize: {
        name: 'Pixel Size',
        type: 'number',
        min: 1,
        max: 20,
        step: 1,
        slider: true
      },
      edgeNormalStrength: {
        name: 'Edge Normal',
        type: 'number',
        min: 0,
        max: 2,
        step: 0.05
      },
      edgeDepthStrength: {
        name: 'Edge Depth',
        type: 'number',
        min: 0,
        max: 1,
        step: 0.05
      }
    },
    defaults: {
      pixelSize: 3,
      edgeNormalStrength: 0.3,
      edgeDepthStrength: 0.4
    }
  },
  glitch: {
    name: 'Glitch',
    update: 'new',
    controls: {
      dt_size: {
        name: 'Power',
        type: 'number',
        min: 0,
        max: 1000
      }
    },
    defaults: {
      dt_size: 64
    }
  },
  ubloom: {
    name: 'Unreal Bloom',
    update: 'update',
    controls: {
      strength: {
        name: 'Strength',
        type: 'number',
        min: 0,
        max: 3,
        step: 0.001
      },
      radius: {
        name: 'Radius',
        type: 'number',
        min: 0,
        max: 1,
        step: 0.01
      },
      threshold: {
        name: 'Threshold',
        type: 'number',
        min: 0,
        max: 1,
        step: 0.001
      },
    },
    defaults: {
      strength: 1,
      radius: 0,
      threshold: 0
    }
  },
  bokeh: {
    name: 'Bokeh',
    controls: {
      focus: {
        name: 'Focus',
        type: 'number',
        min: 10,
        max: 5000,
        step: 1
      },
      aperture: {
        name: 'Aperture',
        type: 'number',
        min: 0,
        max: 10,
        step: 0.01
      },
      maxblur: {
        name: 'Maxblur',
        type: 'number',
        min: 0,
        max: 0.1,
        step: 0.001
      }
    },
    defaults: {
      focus: 100,
      aperture: 5,
      maxblur: 0.01
    }
  },
  vignette: {
    name: 'Vignette',
    controls: {
      offset: {
        name: 'Offset',
        type: 'number',
        min: 0,
        max: 1,
        step: 0.01,
        slider: true
      },
      darkness: {
        name: 'Darkness',
        type: 'number',
        min: 0,
        max: 1,
        step: 0.01,
        slider: true
      }
    },
    defaults: {
      offset: 0.5,
      darkness: 0.5
    }
  },
  grain: {
    name: 'Grain',
    controls: {
      opacity: {
        name: 'Opacity',
        type: 'number',
        min: 0,
        max: 1,
        step: 0.001,
        slider: true
      }
    },
    defaults: {
      opacity: 0.04
    }
  },
  lut: {
    name: 'LUT',
    controls: {
      intensity: {
        name: 'Intensity',
        type: 'number',
        min: 0,
        max: 1,
        step: 0.01,
        slider: true
      },
      lutUrl: {
        name: 'LUT URL (.cube)',
        type: 'string'
      }
    },
    defaults: {
      intensity: 1,
      lutUrl: ''
    }
  }
}

export const CLONE_EFFECTS = {
  clone: {
    name: 'Clone',
    controls: {
      shift: {
        name: 'Shift',
        type: 'object',
        fields: {
          x: { name: 'X', type: 'number' },
          y: { name: 'Y', type: 'number' },
          z: { name: 'Z', type: 'number' }
        }
      }
    }
  }
}
